import { useContext } from 'react';
import { UserContext, type UserContextType } from './UserContext';

export const useUserContext = (): UserContextType => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};
